<template>
  <div class="app-header-frill-launcher">
    <i
      class="ddi ddi-megaphone marker--app-header--frill-announcements-btn"
      icon="megaphone"
    />
    <!-- FRILL WIDGET -->
    <frill-widget />
  </div>
</template>

<script lang="ts">
/* General */
import ddIconButton from '@/components/global/buttons/dd-icon-button.vue'
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'AppHeaderFrillLauncher',
  components: { ddIconButton },
})
</script>

<style lang="scss">
.app-header-frill-launcher {
  font-size: $dd2-size--app-header-icon;
  @include clickable-gray-color-states;
}
</style>
